import { render, staticRenderFns } from "./LanguageDetection.vue?vue&type=template&id=04b6fe54"
import script from "./LanguageDetection.vue?vue&type=script&lang=js"
export * from "./LanguageDetection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports